import { Component, Inject } from '@angular/core';
import { Environment } from 'src/app/classes/environment';


@Component({
	selector: 'app-group-management',
	templateUrl: './group-management.component.html',
	styles: [`
		.container {
			display: flex;
			flex-flow: column nowrap;
			gap: 30px;
		}
		.portalCard{ padding: 0; gap: 0; }
		.portalCard .aTitle{ padding: 30px; cursor: pointer; user-select: none; }
		.aTitle{ margin: 0 20px; }
		.aTitle:hover { text-decoration: underline; text-decoration-color: var(--mainColor); }
		mat-icon { vertical-align: middle; }
		.management{ padding: 0 20px 20px 20px; }
	`]
})
export class GroupManagementComponent {


	bFGVisible = false;
	bCGVisible = false;
	bRVisible = false;
	bDECVisible = false;
	bChatGroupsVisible = false;


	constructor(
		@Inject( "environment" ) public environment: Environment
	) {}


}

